import { render } from "./BranchColumnChart.vue?vue&type=template&id=5dafe43a&scoped=true"
import script from "./BranchColumnChart.vue?vue&type=script&lang=js"
export * from "./BranchColumnChart.vue?vue&type=script&lang=js"

import "./BranchColumnChart.vue?vue&type=style&index=0&id=5dafe43a&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5dafe43a"]])

export default __exports__